import ScopeConstants from "constants/ScopeConstants"

export const DashboardScope = {
    key: ScopeConstants.DASHBOARD,
    tokenSelector: (state) => state.authentication.token
}